import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up


@Component({
  selector: 'app-itemssearch',
  templateUrl: './itemssearch.component.html',
  styleUrls: ['./itemssearch.component.css']
})
export class ItemssearchComponent implements OnInit {
itCode ='' ;
itTName ='' ;
itGName ='' ;
itAName ='' ;
itClass ='' ;
itUnit ='' ;
iTPurchasis = '0' ;
iTMedical ='0' ;
iTMegor ='' ;
iTStore ='' ;
itGrouping ='' ;
compCode ='1' ;
uaserID ='sa' ;
modifiedDate  = '2021-01-01';

itemsList: ItemsModel[] = [];
@Output() submitClicked = new EventEmitter<any>();


  constructor(public itemsService: ItemsService,
              public items: ItemsModel,
              public storage: LocalStorageService,
              public dialogRef: MatDialogRef<ItemssearchComponent>,
              @Inject(MAT_DIALOG_DATA)
              public itemsSelectedData: ItemsModel) { }

  ngOnInit(): void {this.retriveItemsTop();
  }
  retriveItems() {
    this.itemsList = [];
      this.itemsService.getItemsLookup(this.itCode, this.itTName, this.compCode).subscribe((data: ItemsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.itemsList[i] = data[i];
      }
    })
  }
  retriveItemsTop() {

    this.itemsService.getItemsLookupTop(this.compCode).subscribe((data: ItemsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.itemsList[i] = data[i];
      }
    })
  }

  SelectItem(item: ItemsModel){
    this.itemsSelectedData.itCode = item.itCode
    this.itemsSelectedData.itTName = item.itTName
    this.itemsSelectedData.itAName= item.itAName
    this.itemsSelectedData.itGName= item.itGName
    this.itemsSelectedData.itClass= item.itClass

    this.itemsSelectedData.itUnit = item.itUnit
    this.itemsSelectedData.iTPurchasis= item.iTPurchasis
    this.itemsSelectedData.iTMedical= item.iTMedical
    this.itemsSelectedData.iTMegor= item.iTMegor

    this.itemsSelectedData.iTStore = item.iTStore
    this.itemsSelectedData.itGrouping= item.itGrouping

    this.itemsSelectedData.uaserID = item.uaserID
    this.itemsSelectedData.modifiedDate = item.modifiedDate
    this.itemsSelectedData.compCode = item.compCode
    this.submitClicked.emit(this.itemsSelectedData);

    this.dialogRef.close();
  }
}
